export default __webpack_public_path__ + "static/media/usage_tile_bg.be8902da.jpg";